<template>
  <form class="form" @submit.stop.prevent="onSubmit">
    <legend v-if="true"><h5>Submission Mail Configuration</h5></legend>
    <hr />
    <div class="form-group">
      <label for="">Submission Email <span class="text-danger">*</span></label>
      <input
        type="text"
        name=""
        class="form-control"
        id=""
        v-model="email"
        :class="errors['email'] ? 'border border-danger' : ''"
      />
      <span v-if="errors['email']" class="text-danger">{{
        errors["email"][0]
      }}</span>
    </div>
    <div class="form-group">
      <label for="">LSID <span class="text-danger">*</span></label>
      <input
        type="text"
        name=""
        class="form-control"
        id=""
        v-model="lsid"
        :class="errors['lsid'] ? 'border border-danger' : ''"
      />
      <span v-if="errors['lsid']" class="text-danger">{{
        errors["lsid"][0]
      }}</span>
    </div>
    <div class="form-group">
      <label for="">Check Url <span class="text-danger">*</span></label>
      <input
        type="text"
        name=""
        class="form-control"
        id=""
        v-model="check_url"
        :class="errors['check_url'] ? 'border border-danger' : ''"
      />
      <span v-if="errors['check_url']" class="text-danger">{{
        errors["check_url"][0]
      }}</span>
    </div>

    <hr />
    <legend v-if="true"><h5>Configure Outgoing Mail (SMTP)</h5></legend>
    <hr />
    <div id="email-smtp-config">
      <form>
        <div class="form-group">
          <label for=""
            >Outgoing Server <span class="text-danger">*</span></label
          >
          <input
            type="text"
            name=""
            class="form-control"
            id="outgoing_server"
            v-model="outgoing_server"
            :class="errors['outgoing_server'] ? 'border border-danger' : ''"
          />
          <span v-if="errors['outgoing_server']" class="text-danger">{{
            errors["outgoing_server"][0]
          }}</span>
        </div>
        <div class="form-group">
          <label for="">Port <span class="text-danger">*</span></label>
          <input
            type="number"
            name=""
            class="form-control"
            id="port"
            v-model="port"
            :class="errors['port'] ? 'border border-danger' : ''"
          />
          <span v-if="errors['port']" class="text-danger">{{
            errors["port"][0]
          }}</span>
        </div>

        <div class="form-group">
          <label for="">Username <span class="text-danger">*</span></label>
          <input
            type="email"
            name=""
            class="form-control"
            id="username"
            v-model="username"
            :class="errors['username'] ? 'border border-danger' : ''"
          />
          <span v-if="errors['username']" class="text-danger">{{
            errors["username"][0]
          }}</span>
        </div>

        <div class="form-group mb-1">
          <label for="">Password <span class="text-danger">*</span></label>
          <div class="input-group">
            <input
              :type="outgoing_password_type"
              name=""
              class="form-control"
              id="password"
              v-model="password"
              :class="errors['password'] ? 'border border-danger' : ''"
            />
            <div
              class="input-group-append"
              style="cursor: pointer"
              @click="showOutgoingPassword()"
            >
              <span class="input-group-text">
                <!-- <i class="fa fa-eye"></i> -->
                <i
                  :class="
                    outgoing_password_type == 'password'
                      ? 'fa fa-eye'
                      : 'fa fa-eye-slash'
                  "
                ></i>
              </span>
            </div>
          </div>

          <span v-if="errors['password']" class="text-danger">{{
            errors["password"][0]
          }}</span>
        </div>
        <div class="row mt-4">
          <div class="col-md-12">
            <label for="">Connect with SSL/TLS</label>
          </div>
          <div class="col-md-12">
            <div class="can-toggle">
              <input id="a" type="checkbox" v-model="ssl_tls" />
              <label for="a">
                <div
                  class="can-toggle__switch"
                  data-checked="TLS"
                  data-unchecked="SSL"
                ></div>
              </label>
            </div>
          </div>
        </div>
      </form>
    </div>

    <hr />
    <legend v-if="true"><h5>Configure Incoming Mail (IMAP)</h5></legend>
    <div id="email-smtp-config">
      <form>
        <div class="form-group">
          <label for=""
            >Incoming Server <span class="text-danger">*</span></label
          >
          <input
            type="text"
            name=""
            class="form-control"
            id="incoming_server"
            v-model="incoming_server"
            :class="errors['incoming_server'] ? 'border border-danger' : ''"
          />
          <span v-if="errors['incoming_server']" class="text-danger">{{
            errors["incoming_server"][0]
          }}</span>
        </div>

        <div class="form-group">
          <label for="">Username <span class="text-danger">*</span></label>
          <input
            type="email"
            name=""
            class="form-control"
            id="incoming_username"
            v-model="incoming_username"
            :class="errors['incoming_username'] ? 'border border-danger' : ''"
          />
          <span v-if="errors['incoming_username']" class="text-danger">{{
            errors["incoming_username"][0]
          }}</span>
        </div>

        <div class="form-group mb-1">
          <label for="">Password <span class="text-danger">*</span></label>
          <div class="input-group">
            <input
              :type="incoming_password_type"
              name=""
              class="form-control"
              id="incoming_password"
              v-model="incoming_password"
              :class="errors['incoming_password'] ? 'border border-danger' : ''"
            />
            <div
              class="input-group-append"
              style="cursor: pointer"
              @click="showIncomingPassword()"
            >
              <span class="input-group-text">
                <!-- <i class="fa fa-eye"></i> -->
                <i
                  :class="
                    incoming_password_type == 'password'
                      ? 'fa fa-eye'
                      : 'fa fa-eye-slash'
                  "
                ></i>
              </span>
            </div>
          </div>

          <span v-if="errors['incoming_password']" class="text-danger">{{
            errors["incoming_password"][0]
          }}</span>
        </div>
      </form>
    </div>
    <!-- 
      <h4 @click="checkTwilioKey()">Checkme</h4> -->
    <button
      class="btn btn-success"
      ref="kt_fdle_config_submit"
      style="float: right"
    >
      Submit
    </button>
  </form>
</template>

<script>
import {
  FETCH_FDLE_CONFIG,
  SUBMIT_FDLE_CONFIG,
} from "@/core/services/store/actions.type";
export default {
  data() {
    return {
      email: "",
      lsid: "",
      check_url: "",
      errors: [],
      id: 0,
      username: "",
      outgoing_server: "",
      port: 465,
      ssl_tls: 0,
      password: "",
      outgoing_password_type: "password",
      incoming_username: "",
      incoming_server: "",
      incoming_password: "",
      incoming_password_type: "password",
      processing: false,
    };
  },
  created() {
    this.$store.dispatch(FETCH_FDLE_CONFIG).then((data) => {
      var data_ = data.data;
      this.email = data_.email ? data_.email : "";
      this.lsid = data_.lsid ? data_.lsid : "";
      this.check_url = data_.check_url ? data_.check_url : "";
      this.id = data_.id ? data_.id : 0;
      this.username = data.data.username;
      this.password = data.data.password;
      this.outgoing_server = data.data.outgoing_server;
      this.incoming_server = data.data.incoming_server;
      this.port = data.data.port;
      this.ssl_tls = data.data.connect_with_ssl_tls;
      this.incoming_username = data.data.incoming_username;
      this.incoming_password = data.data.incoming_password;
    });
  },

  methods: {
    // checkTwilioKey() {
    //   const client = require("twilio")(this.account_sid, this.auth_token);
    //   client.newKeys.create({friendlyName: 'User Joey'})
    //           .then(new_key => console.log(new_key.sid));
    // },
    showOutgoingPassword() {
      if (this.outgoing_password_type === "password") {
        this.outgoing_password_type = "text";
      } else {
        this.outgoing_password_type = "password";
      }
    },
    showIncomingPassword() {
      if (this.incoming_password_type === "password") {
        this.incoming_password_type = "text";
      } else {
        this.incoming_password_type = "password";
      }
    },
    onSubmit() {
      this.errors = [];
      const submitButton = this.$refs["kt_fdle_config_submit"];
      submitButton.disabled = true;
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      var data = {
        email: this.email,
        lsid: this.lsid,
        id_: this.id,
        check_url: this.check_url,
        username: this.username,
        password: this.password,
        outgoing_server: this.outgoing_server,
        incoming_server: this.incoming_server,
        port: this.port,
        connect_with_ssl_tls: this.ssl_tls,
        incoming_username: this.incoming_username,
        incoming_password: this.incoming_password,
      };
      this.$store
        .dispatch(SUBMIT_FDLE_CONFIG, data)
        .then((data) => {
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
          submitButton.disabled = false;
          this.$toastr.s(data.msg);
        })
        .catch((err) => {
          this.errors = err.msg;
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
          submitButton.disabled = false;
          // this.$toastr.e(err.msg);
        });
    },
  },
};
</script>
<style lang="scss">
.form-body {
  .card-footer {
    z-index: 9;
  }
}
#email-smtp-config {
  @mixin can-toggle-branding(
    $can-toggle-off-color: #4c4c4c,
    $can-toggle-on-color: #4c4c4c,
    $can-toggle-inactive-text: rgba(#fff, 0.5),
    $can-toggle-transition: cubic-bezier(0, 1, 0.5, 1)
  ) {
    input[type="checkbox"] {
      &[disabled] ~ label {
        color: rgba($can-toggle-off-color, 0.5);
      }

      &:focus ~ label,
      &:hover ~ label {
        .can-toggle__switch {
          background-color: $can-toggle-off-color;
          &:after {
            color: darken($can-toggle-off-color, 10%);
          }
        }
      }
      &:hover ~ label {
        color: darken($can-toggle-off-color, 5%);
      }
      &:checked {
        ~ label {
          &:hover {
            color: darken($can-toggle-on-color, 3%);
          }

          .can-toggle__switch {
            background-color: lighten($can-toggle-on-color, 5%);
            &:after {
              color: darken($can-toggle-on-color, 5%);
            }
          }
        }

        &:focus,
        &:hover {
          ~ label {
            .can-toggle__switch {
              background-color: $can-toggle-on-color;
              &:after {
                color: darken($can-toggle-on-color, 10%);
              }
            }
          }
        }
      }
    }

    label {
      .can-toggle__label-text {
        flex: 1;
      }

      .can-toggle__switch {
        transition: background-color 0.3s $can-toggle-transition;
        background: lighten($can-toggle-off-color, 5%);
        &:before {
          color: $can-toggle-inactive-text;
        }
        &:after {
          // Autoprefixer choked here, so making the prefixes explicit
          -webkit-transition: -webkit-transform 0.3s $can-toggle-transition;
          transition: transform 0.3s $can-toggle-transition;
          color: $can-toggle-off-color;
        }
      }
    }
  }

  @mixin can-toggle-appearance(
    $can-toggle-width: 134px,
    $can-toggle-height: 36px,
    $can-toggle-border-radius: 4px,
    $can-toggle-offset: 2px,
    $can-toggle-label-font-size: 14px,
    $can-toggle-switch-font-size: 12px,
    $can-toggle-shadow: 0 3px 3px rgba(black, 0.4)
  ) {
    $can-toggle-switch-width: $can-toggle-width/2;

    input[type="checkbox"] {
      &:focus ~ label,
      &:hover ~ label {
        .can-toggle__switch {
          &:after {
            box-shadow: $can-toggle-shadow;
          }
        }
      }

      &:checked {
        ~ label {
          .can-toggle__switch {
            &:after {
              transform: translate3d(
                $can-toggle-width -
                  ($can-toggle-switch-width + $can-toggle-offset),
                0,
                0
              );
            }
          }
        }
        &:focus,
        &:hover {
          ~ label {
            .can-toggle__switch {
              &:after {
                box-shadow: $can-toggle-shadow;
              }
            }
          }
        }
      }
    }

    label {
      font-size: $can-toggle-label-font-size;

      .can-toggle__switch {
        height: $can-toggle-height;
        flex: 0 0 $can-toggle-width;
        border-radius: $can-toggle-border-radius;

        &:before {
          left: $can-toggle-width/2;
          font-size: $can-toggle-switch-font-size;
          line-height: $can-toggle-height;
          width: $can-toggle-width/2;
          padding: 0 12px;
        }

        &:after {
          top: $can-toggle-offset;
          left: $can-toggle-offset;
          border-radius: $can-toggle-border-radius/2;
          width: $can-toggle-switch-width - $can-toggle-offset;
          line-height: $can-toggle-height - ($can-toggle-offset * 2);
          font-size: $can-toggle-switch-font-size;
        }

        &:hover {
          &:after {
            box-shadow: $can-toggle-shadow;
          }
        }
      }
    }
  }

  .can-toggle {
    position: relative;
    *,
    *:before,
    *:after {
      box-sizing: border-box;
    }
    //overflow: hidden;

    input[type="checkbox"] {
      opacity: 0;
      position: absolute;
      top: 0;
      left: 0;

      &[disabled] ~ label {
        pointer-events: none;
        .can-toggle__switch {
          opacity: 0.4;
        }
      }

      &:checked {
        ~ label {
          .can-toggle__switch {
            &:before {
              content: attr(data-unchecked);
              left: 0;
            }

            &:after {
              content: attr(data-checked);
            }
          }
        }

        &:focus,
        &:hover {
          ~ label {
          }
        }
      }
    }

    label {
      user-select: none;
      position: relative;
      display: flex;
      align-items: center;

      .can-toggle__label-text {
        flex: 1;
        padding-left: 32px;
      }

      .can-toggle__switch {
        position: relative;

        &:before {
          content: attr(data-checked);
          position: absolute;
          top: 0;
          text-transform: uppercase;
          text-align: center;
        }

        &:after {
          content: attr(data-unchecked);
          position: absolute;
          z-index: 5;
          text-transform: uppercase;
          text-align: center;
          background: white;
          transform: translate3d(0, 0, 0);
        }
      }
    }

    // Default values for .can-toggle class
    @include can-toggle-branding;
    @include can-toggle-appearance;

    // Create toggles of different sizes by overriding the can-toggle-appearance mixin defaults
    &.can-toggle--size-small {
      @include can-toggle-appearance(
        90px,
        // Toggle width
        28px,
        // Toggle height
        2px,
        // Toggle border radius
        1px,
        // Offset (distance btw switch and box)
        13px,
        // Label font size
        10px,
        // Switch font size
        0 2px 2px rgba(black, 0.4) / Switch shadow on hover/focus
      );
    }
  }
}
</style>
